import React from 'react';
import { SOCIALS, SPOTIFY_PLAYLIST_URL } from '../../data/site';
import { BrandIcon } from '../BrandIcon';
import { LOGO_TRI } from '../logos';
const FOOTER_LINKS = [...SOCIALS.map(s => ({
  href: s.href,
  icon: s.icon,
  label: `${s.platform} ${s.handle}`
})), {
  href: SPOTIFY_PLAYLIST_URL,
  icon: 'spotify' as const,
  label: 'Spotify playlist'
}];
export function Footer() {
  return <footer className="relative w-full border-t border-white/10 px-5 py-12 sm:px-8" data-id="element-187" data-mp="1mfmnirm7pmo8">
      <div className="mx-auto flex w-full max-w-7xl flex-col items-center gap-8 text-center md:flex-row md:justify-between md:text-left" data-id="element-188" data-mp="1hhbeuk7nli7l">
        <div className="flex flex-col items-center md:items-start" data-id="element-189" data-mp="1w6r39tjppbk4">
          <a href="#top" className="flex items-center justify-center gap-2.5 font-display text-[0.7rem] tracking-[0.18em] text-white md:justify-start" data-id="element-190" data-mp="1repitkce4ej0">
            <img src={LOGO_TRI} alt="" aria-hidden="true" className="h-8 w-auto" data-id="element-191" data-mp="yqlep39gw9if" />
            FUTURE ASTRONAUT
          </a>
          <p className="mt-3 font-tech text-xs tracking-[0.24em] text-magenta" data-id="element-192" data-mp="1eiviwhjnov1k">
            Dream · Love · Impact
          </p>
        </div>

        <ul className="flex items-center gap-3" data-id="element-193" data-mp="1ihuj5oug03mo">
          {FOOTER_LINKS.map(link => <li key={link.label} data-id="element-194" data-mp="1nb5vu6lxremi">
              <a href={link.href} target="_blank" rel="noopener noreferrer" aria-label={link.label} className="glass flex h-11 w-11 items-center justify-center rounded-full text-white/65 transition-[transform,color,border-color] duration-200 ease-expo hover:-translate-y-0.5 hover:border-violet/60 hover:text-cyan" data-id="element-195" data-mp="1s9h3caordd1k">
                <BrandIcon name={link.icon} className="h-[18px] w-[18px]" data-id="element-196" data-mp="19jimp66wabmb" />
              </a>
            </li>)}
        </ul>
      </div>
      <p className="mx-auto mt-10 w-full max-w-7xl text-center font-tech text-[0.7rem] tracking-[0.14em] text-white/30 md:text-left" data-id="element-197" data-mp="2fyjjtf7nozuh">
        © 2026 Future Astronaut · Gulf Coast, USA
      </p>
    </footer>;
}